import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import CloudAppAPI from "../../api/CloudAppAPI";
import { CloudApp } from "../../../types/GlobalInterfaces";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useGetCloudApps = (cloudID?: string, disabled?: boolean) => {
  const tenantID = useAtomValue(tenantIDAtom);
  const workspaceID = useAtomValue(workspaceIdAtom);

  const cloudApps = useQuery<CloudApp[]>({
    queryKey: ["cloudApps", tenantID ?? cloudID],
    queryFn: () =>
      CloudAppAPI.getAllCloudApps(workspaceID, cloudID).then((data) => {
        return data.data.data.apps;
      }),
    enabled: !!workspaceID && (!!cloudID || !!tenantID) && !disabled,
  });

  return {
    cloudApps: cloudApps.data,
    loadingApps: cloudApps.isLoading,
    error: cloudApps.isError,
  };
};

export default useGetCloudApps;
